import DataGrid from './DataGrid';
import { IDataGridColumn } from './models';

export default DataGrid;
export type { IDataGridColumn };
